export default __webpack_public_path__ + "static/media/musaberul.b2477094.png";